import React from "react";
import PropTypes from "prop-types";

import HeatmapWorldMap from "./HeatmapWorldMap";
import ComponentMissing from "../../Debug/ComponentMissing";

const WordldMapSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  countries,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    countries,
    animation,
  };

  function switchWorldMap() {
    switch (layout) {
      case "heatmap":
        return <HeatmapWorldMap properties={properties} />;
      default:
        return <ComponentMissing type="WorldMap" subType={layout} />;
    }
  }

  return switchWorldMap();
};

WordldMapSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  countries: PropTypes.instanceOf(Array),
  animation: PropTypes.instanceOf(Object),
};

export default WordldMapSwitcher;
